module.exports = __webpack_public_path__ + "media/images/front/varieties/SALUSTIANA-897df166cefb3304e41b59e950e3cb99.jpg";